<swal [swalFireOnInit]="true" [showConfirmButton]="false" [allowOutsideClick]="false">
  <ng-container *swalPortal>
    <rek-spinner></rek-spinner>
    <div class="rek-loading-modal__title">
      {{ title | translate }}<br>
    </div>
    <div class="rek-loading-modal__subtitle">
      {{ subtitle | translate }}
    </div>
  </ng-container>
</swal>
